import { Pipe, PipeTransform } from '@angular/core';

export interface PrettifyChar {
	char: string;
	type: 'letter' | 'number';
}

@Pipe({ name: 'prettifyChars' })
export class PrettifyCharsPipe implements PipeTransform {
	transform(code: string | null): PrettifyChar[] {
		if (!code) return [];

		return code.split('').map((char) => {
			const isNumber = /[0-9]/.test(char);
			return {
				char,
				type: isNumber ? 'number' : 'letter',
			};
		});
	}
}
